import Logo from "@/components/header/logo";
import Detalhes from "@/features/Detalhes";
import StepAcordions from "@/components/acorddions/stepAcordions";
import Usuario from "@/features/Usuario";
import Pagamentos from "@/features/Pagamentos";
import Sucesso from "@/features/Sucesso";
import Rodape from "@/features/Rodape";
import {useSelector} from "react-redux";
import {GET_USER_TAB, GET_USER_STEP} from "@/store/slices/appSlice";

import PrecisaAjuda from "@/features/PrecisaAjuda";
import Modals from "@/components/modals";

import Chat from "@/features/Chat";
import Mensagem from "@/features/Mensagem";
import { GET_USER } from "@/store/slices/userSlice";
import { GET_PAYMENT_DATA } from "@/store/slices/paymentSlice";

export default function Digital() {
    const USER_TAB = useSelector(GET_USER_TAB)
    const finishStep = 3;
    const current = useSelector(GET_USER_STEP)
    const USER = useSelector(GET_USER)
    const PAYMENT = useSelector(GET_PAYMENT_DATA)
    
    const FormOfPayment = () => {
        if(PAYMENT.forma === 'cc'){
            return PAYMENT.cartao.numero
        }
        else{
            return PAYMENT.debito.agencia
        }   
    }
      
    const EncryptAccount = () => {
        const string = FormOfPayment()
        const lastNumbers = string?.toString().slice(-4)
        return `**** **** **** ${lastNumbers}`
    }

    return (
        <>
            <Logo/>
            <Detalhes/>
            <StepAcordions title={'Identificação'} subtitle={USER.email} step={'1'} page="digital">
              <Usuario />
            </StepAcordions>
            <StepAcordions title={'Pagamento'} step={'2'} subtitle={EncryptAccount()}>
                <Pagamentos />
            </StepAcordions>
            {current === finishStep && <Sucesso />}
            <PrecisaAjuda />
            {USER_TAB === 3 && 
            <>
                <Chat />
                <Mensagem />
            </>            

            }
            <Rodape />
            <Modals />
        </>
    )
}
